/**
 * Query keys factory for agent execution queries
 * Provides consistent query key generation for TanStack Query
 */

export const agentExecutionKeys = {
  all: ["agent-executions"] as const,
  lists: () => [...agentExecutionKeys.all, "list"] as const,
  list: (filters?: {
    status?: number;
    agent_type?: string;
    search?: string;
    channel?: string;
    from?: string;
    to?: string;
    limit?: number;
    offset?: number;
  }) => [...agentExecutionKeys.lists(), filters] as const,
  filterOptions: () => [...agentExecutionKeys.all, "filter-options"] as const,
  details: () => [...agentExecutionKeys.all, "detail"] as const,
  detail: (id: string) => [...agentExecutionKeys.details(), id] as const,
  stats: () => [...agentExecutionKeys.all, "stats"] as const,
  companyStats: (companyId: string) =>
    [...agentExecutionKeys.stats(), companyId] as const,
} as const;
